import spnBatua from '../assets/hospital/spnBatua.JPG'
import klinikBhayangkara from '../assets/hospital/klinikBhayangkara.jpg'
import klinikBiddokkes from '../assets/hospital/klinikBiddokkes.jpg'
import klinikUnismuh from '../assets/hospital/klinikUnismuh.jpg'
import rsDadi from '../assets/hospital/rsDadi.jpg'


export const PoskoVaksin = [
    {
        key: 'marker1',
        position: [-5.144860984832668, 119.46490156713197],
        img: spnBatua,
        name: 'SPN POLDA SULSEL',
        organizer: ['POLDA Provinsi Sulawesi Selatan', 'DPD KNPI'],
        address: 'JI. Urip Sumoharjo No.KM.7, Tello Baru, Kota Makassar.',
        date: ['05-09-2021'],
        time: '08:00 - Selesai',
        dose: ['Dosis Vaksin 1'],
        vaccine: '',
        website: '',
        phoneNumber: '+62811447224'
    },
    {
        key: 'marker2',
        position: [-5.142635968980141, 119.45776523904598],
        img: klinikBhayangkara,
        name: 'Klinik Bhayangkara Panaikang',
        organizer: ['POLDA Sulawesi Selatan'],
        address: 'Jl. Urip Sumoharjo Komp Aspol Panaikang No.KM7, Karampuang, Kota Makassar.',
        date: ['06-09-2021', '07-09-2021', '08-09-2021','09-09-2021', '10-09-2021', '11-09-2021',
        '13-09-2021', '14-09-2021', '15-09-2021','16-09-2021', '17-09-2021', '18-09-2021', 
        '20-09-2021', '21-09-2021', '22-09-2021','23-09-2021', '24-09-2021', '25-09-2021',
        '27-09-2021', '28-09-2021', '29-09-2021','30-09-2021'],
        time: '08:00 - Selesai',
        dose: ['Dosis Vaksin 1', 'Dosis Vaksin 2'],
        vaccine: ['Sinovac', 'Astrazeneca'],
        website: '',
        phoneNumber: ''
    },
    {
        key: 'marker3',
        position: [-5.097261318642622, 119.51277184196185],
        img: klinikBiddokkes,
        name: 'Klinik Biddokkes Polda Sulsel',
        organizer: ['POLDA Sulawesi Selatan'],
        address: 'Jl. Poros Barru - Makassar ,Halte bus samping polda Makassar, Pai, Kec. Biringkanaya, Kota Makassar.',
        date: ['06-09-2021', '07-09-2021', '08-09-2021','09-09-2021', '10-09-2021', '11-09-2021',
        '13-09-2021', '14-09-2021', '15-09-2021','16-09-2021', '17-09-2021', '18-09-2021', 
        '20-09-2021', '21-09-2021', '22-09-2021','23-09-2021', '24-09-2021', '25-09-2021',
        '27-09-2021', '28-09-2021', '29-09-2021','30-09-2021'],
        time: '08:00 - Selesai',
        dose: ['Dosis Vaksin 1', 'Dosis Vaksin 2'],
        vaccine: ['Sinovac', 'Astrazeneca'],
        website: '',
        phoneNumber: ''
    },
    {
        key: 'marker4',
        position: [-5.181337338362359, 119.44138246161357],
        img: klinikUnismuh,
        name: 'Klinik Unismuh Medical Centre',
        organizer: ['POLDA Sulawesi Selatan'],
        address: 'Jl. Talasalapang No.4, Gn. Sari, Kec. Rappocini, Kota Makassar.',
        date: ['02-09-2021', '03-09-2021', '06-09-2021', '07-09-2021', '08-09-2021','09-09-2021', '10-09-2021',
        '13-09-2021', '14-09-2021', '15-09-2021','16-09-2021', '17-09-2021', 
        '20-09-2021', '21-09-2021', '22-09-2021','23-09-2021', '24-09-2021',
        '27-09-2021', '28-09-2021', '29-09-2021','30-09-2021'],
        time: '09:00 - Selesai',
        dose: ['Dosis Vaksin 1'],
        vaccine: ['Sinovac'],
        website: 'https://med.unismuh.ac.id/vaksin/',
        phoneNumber: '+6281356789119'
    },
    {
        key: 'marker5',
        position: [-5.15209117198648, 119.42226729778665],
        img: rsDadi,
        name: 'Rumah Sakit Khusus Daerah Dadi',
        organizer: ['Rumah Sakit Khusus Daerah Dadi'],
        address: 'Jl. Lanto Dg. Pasewang, Maricaya Sel, Kota Makassar.',
        date: ['07-09-2021','09-09-2021', '14-09-2021', '16-09-2021', '21-09-2021','23-09-2021', '28-09-2021', '30-09-2021'],
        time: '08:00 - Selesai',
        dose: ['Dosis Vaksin 1', 'Dosis Vaksin 2'],
        vaccine: ['Moderna'],
        website: 'https://linktr.ee/satgassulsel',
        phoneNumber: '+6282154021119'
    },
    
]